<template>
  <div class="emap-flow-next-step-m" v-if="visible">
    <div class="emap-flow-next-step-item"  v-if="cur_node_info.nodeName" >
      <van-cell :title="labels.cur_node" :value="cur_node_info.nodeName" title-class="van-field__label"/>
    </div>
    <div class="emap-flow-next-step-item" v-if="cur_node_info.documentation">
      <van-cell :title="labels.cur_node_desc" :value="cur_node_info.documentation" title-class="van-field__label"/>
    </div>
    <!-- 下一步节点选择 -->
    <div class="emap-flow-next-step-item" v-if="showNextNode">
      <van-cell 
        :title="labels.node" 
        :is-link="node_list.length != 1" 
        :value="node_display || nodeplaceholder" 
        :required="required" 
        :value-class="nodeClass" 
        @click="nodeClick"
        title-class="van-field__label"
        v-if="showNextNode"/>
      <!-- 下一步节点选项弹出层 -->
      <van-popup 
        v-model="nodePopup" 
        position="bottom"
        get-container="body">
        <van-picker
          show-toolbar
          :columns="node_list"
          value-key="nodeName"
          :default-index="nodeIdIndex"
          @cancel="nodePopup = false"
          @confirm="nodeConfirm"/>
      </van-popup>
    </div>
    <!-- 下一步节点说明 -->
    <div class="emap-flow-next-step-item" v-if="showNextNode && cur_node.documentation && schema ==='default'">
      <van-cell 
        :title="labels.node_desc" 
        :value="cur_node.documentation" 
        title-class="van-field__label"/>
    </div>
    <div class="emap-flow-next-step-item" v-if="$slots.customItem">
      <slot name="customItem"></slot>
    </div>
    <!-- 下一步处理人/组选择 -->
    <div class="emap-flow-next-step-item" v-if="cur_node.isEndNode !== '1' && showNextAssignees">
      <van-cell 
        :title="!isMultiInstance ? labels.assignee : labels.assigneeGroup" 
        is-link
        :value="assignee_display || '请选择'" 
        :required="required" 
        :value-class="assigneeClass" 
        @click="assigneeClick"
        title-class="van-field__label"
        v-if="showNextAssignees">
        <template #right-icon>
          <van-icon name="arrow" class="van-cell__right-icon" v-if="node && assignee_list.length != 1 && !asyncAssignee"/>
          <van-loading type="spinner" size="24px" v-if="asyncAssignee"/>
        </template>
      </van-cell>
      <!-- 下一步办理人选项弹出层 -->
       <van-popup 
        v-model="assigneesPopup" 
        position="bottom"
        get-container="body">
        <div class="van-hairline--top-bottom van-picker__toolbar">
          <button type="button" class="van-picker__cancel" @click="assigneesCancel">取消</button>
          <button type="button" class="van-picker__confirm" @click="assigneesConfirm">确认</button>
        </div>
        <van-search
          v-model.trim="keyword"
          show-action
          placeholder="请输入搜索关键词"
          @clear="onClear"
          @search="onSearch"
          style="padding: 5px 12px">
          <template #action>
            <div @click="onSearch(keyword)">搜索</div>
          </template>
        </van-search>
        <template v-if="isMultiInstance || multiple">
          <van-checkbox-group v-model="assigneesChecked" class="checkbox-group-container">
            <van-cell-group>
              <van-cell
                v-for="(item, index) in assignee_list"
                clickable
                :key="index"
                @click="toggle(index)">
                <van-checkbox
                  :name="item.userId"
                  ref="checkboxes"
                  shape="square"
                  style="min-height:24px">
                  {{item.display}}
                </van-checkbox>
              </van-cell>
            </van-cell-group>
          </van-checkbox-group>
        </template>
        <template v-else>
          <van-radio-group v-model="assigneesChecked" class="checkbox-group-container">
            <van-cell-group>
              <van-cell 
                v-for="(item, index) in assignee_list"
                :key="index"
                clickable 
                @click="assigneesChecked === item.userId">
                <van-radio slot="right-icon" :name="item.userId">{{item.display}}</van-radio>
              </van-cell>
            </van-cell-group>
          </van-radio-group>
        </template>
      </van-popup>
    </div>
    <tg-tree
      v-if="canCustom && defaultCustom" 
      v-model="customAssigneesPopup" 
      :key-id="assignees"
      :key-name="keyName"
      :options="treeOptions"
      :search-options="treeSearchOptions"
      :parent-selectable="false" 
      :is-view="false" 
      :is-async="true"
      :multiple="multiple"
      hasSearch
      @on-search="$_loadtreeSearch"
      @selector-click="$_loadTreeOptions"
      @selected-click="$_getNextAssigneesSelected">
    </tg-tree>

    <!--添加办理人 -->
    <div class="emap-flow-next-step-item" v-if="cur_node.isEndNode !== '1' && showAddNextAssignees && !addAssigneeHidden">
      <van-cell 
        :title="labels.addAssignee" 
        is-link
        :value="add_assignees_display || '请选择'" 
        :required="false" 
        :value-class="assigneeClass" 
        @click="add_assigneeClick"
        title-class="van-field__label">
        <template #right-icon>
          <van-icon name="arrow" class="van-cell__right-icon" v-if="node && !asyncAssignee"/>
          <van-loading type="spinner" size="24px" v-if="asyncAssignee"/>
        </template>
      </van-cell>
    </div>
    <!--添加新的处理选择人员,默认多选 -->
     <tg-tree
      v-model="add_assigneesPopup" 
      :key-id="assigneesAdd"
      :key-name="keyName2"
      :options="treeOptions"
      :search-options="treeSearchOptions"
      :parent-selectable="false" 
      :is-view="false" 
      :is-async="true"
      multiple
      hasSearch
      @on-search="$_loadtreeSearch"
      @selector-click="$_loadTreeOptions"
      @selected-click="$_getAddAssigneesSelected">
    </tg-tree>

    <!-- 被传阅人 -->
    <div class="emap-flow-next-step-item" v-if="hasCirculate">
      <van-cell 
        :title="labels.circulator" 
        is-link
        :value="circulator_display || assigneeplaceholder" 
        :required="required" 
        :value-class="circulatorClass" 
        @click="circulatorClick"
        title-class="van-field__label">
        <template #right-icon>
          <van-icon name="arrow" class="van-cell__right-icon"/>
        </template>
      </van-cell>
      <van-popup 
        v-model="circulatorsPopup" 
        position="bottom"
        get-container="body"
        v-if="circulatorSelectFalg">
        <div class="van-hairline--top-bottom van-picker__toolbar">
          <button type="button" class="van-picker__cancel" @click="circulatorsCancel">取消</button>
          <button type="button" class="van-picker__confirm" @click="circulatorsConfirm">确认</button>
        </div>
        <van-search
          v-if="false"
          v-model.trim="keyword"
          show-action
          placeholder="请输入搜索关键词"
          @clear="onClear"
          @search="onSearch"
          style="padding: 5px 12px">
          <template #action>
            <div @click="onSearch(keyword)">搜索</div>
          </template>
        </van-search>
        <template>
          <van-checkbox-group v-model="circulatorChecked" class="checkbox-group-container">
            <van-cell-group>
              <van-cell
                v-for="(item, index) in circulator_list"
                clickable
                :key="index"
                @click="toggle(index)"
              >
                <van-checkbox
                  :name="item.userId"
                  ref="checkboxes"
                  shape="square"
                  style="min-height:24px"
                >
                  {{item.display}}
                </van-checkbox>
              </van-cell>
            </van-cell-group>
          </van-checkbox-group>
        </template>
      </van-popup>
    </div>
    <tg-tree
      v-if="hasCirculate && !circulatorSelectFalg" 
      v-model="customCirculatorsPopup" 
      :key-id="circulators"
      :key-name="keyName1"
      :options="treeOptions"
      :search-options="treeSearchOptions"
      :parent-selectable="false" 
      :is-view="false" 
      :is-async="true"
      multiple
      hasSearch
      @on-search="$_loadtreeSearch"
      @selector-click="$_loadTreeOptions"
      @selected-click="$_getCirculatorSelected">
    </tg-tree>
  </div>
</template>
<script>
  import NextStepMixin from "mixins/emapflow-next-step"
  import { getUsers } from '@/api'
  import { encode18bit }  from 'utils'
  import { TgTree } from "tg-tree"
  export default {
    name: "emap-flow-next-step-m",
    components: {
      [TgTree.name]: TgTree
    },
    data() {
      return {
        node_display: '',
        nodePopup: false,
        nodeIdIndex: 0,
        assignee_display: '',
        assigneesChecked: null, // [Array|String]
        assigneesPopup: false,
        customAssigneesPopup: false,
        treeOptions: [],
        treeSearchOptions: [],
        /**添加办理人start */
        keyName2: '',
        add_assignees_display:'',
        add_assigneesPopup:false,
        /**添加办理人end */
        keyName: '',
        keyName1: '',
        keyword: '',
        sourcedata: null,
        circulator_display: '',
        circulatorChecked: [],
        circulatorsPopup: false,
        customCirculatorsPopup: false,
        emapflowpickFlag: null
      }
    },
    props: {
      nodeplaceholder: {
        type: String,
        default: '请选择下一步节点'
      },
      assigneeplaceholder: {
        type: String,
        default: "请选择"
      },
      required: {
        type: Boolean,
        default: true
      },
      multiple: { // 自定义选人模式开启时，是否开启多选
        type: Boolean,
        default: true
      }
    },
    mixins: [NextStepMixin],
    computed: {
      nodeClass() {
        return this.nextstepObj.nextNodeId != null && this.nextstepObj.nextNodeId != '' ? 'selected' : ''
      },
      assigneeClass() {
        return this.nextstepObj.nextAssignees != null && this.nextstepObj.nextAssignees != '' ? 'selected' : ''
      },
      circulatorClass() {
        return this.nextstepObj.circulatedUsers != null && this.nextstepObj.circulatedUsers != '' ? 'selected' : ''
      },
      canCustom() {
        return !!this.node_list.length
      }
    },
    methods: {
      nodeClick() {
        if(this.schema == 'simple' && !this.node_list.length) {
          this.getNextNodes();
        } else {
          if(this.node_list.length == 1) return
        }
        this.nodePopup = true;
      },
      nodeConfirm(value, index) {
        if(value == null) return
        if(this.nodeIdIndex !== index || (this.nodeIdIndex === index && !this.node)) {
          this.cur_node = value;
          this.assigneeClear();
          this.getAssignees();
        }
        this.nodeIdIndex = index;
        this.node = value.nodeId;
        this.node_display = value.nodeName;
        this.nodePopup = false;
      },
      assigneeClear() {
        this.assignees = [];
        this.assigneesChecked = this.multiple ? [] : '';
        this.assignee_list = [];
        this.assignee_display = "";
        this.keyName = "";
      },
      assigneeClick() {
        if(this.assignee_list.length == 1 || this.asyncAssignee) return
        if(!this.cur_node.nodeId) {
          this.toastMsg("请先选择下一步节点")
          return
        }
        this.assigneesChecked = this.multiple ? Object.assign([], this.assignees) : this.assignees[0];
        this.keyword = '';
        if(this.assignee_list.length || this.isMultiInstance) {
          this.assigneesPopup = true;
        }else{
          if(!this.defaultCustom || this.customAssignee) {
            this.$emit("custom-select", this.cur_node.nodeId, this.cur_node);
          } else {
            this.customAssigneesPopup = true;
            this.treeOptions = [];
            this.$_loadTreeOptions();
          }
        }
      },

      /**添加办理人 */
      add_assigneeClick() {
        if(this.asyncAssignee) return
        if(!this.cur_node.nodeId) {
          this.toastMsg("请先选择下一步节点")
          return
        }
        this.add_assigneesPopup = true;
        this.treeOptions = [];
        this.$_loadTreeOptions();
      },

      circulatorClick() {
        if(this.circulator_list.length == 1) return
        this.circulatorChecked = Object.assign([], this.circulators);
        if(this.circulator_list.length) {
          this.circulatorsPopup = true;
        }else{
          this.customCirculatorsPopup = true;
          this.treeOptions = [];
          this.$_loadTreeOptions();
        }
      },
      toggle(index) {
        this.$refs.checkboxes[index].toggle();
      },
      onClear() {
        this.assignee_list = JSON.parse(JSON.stringify(this.sourcedata));
        this.sourcedata = null;
      },
      onSearch(value) {
        if(value) {
          if(!this.sourcedata) this.sourcedata = JSON.parse(JSON.stringify(this.assignee_list));
          this.assignee_list = this.sourcedata.filter(list => (list.userName || list.display).indexOf(value) > -1);
        } else {
          if(this.sourcedata) this.onClear();
        }
      },
      assigneesConfirm() {
        if(this.sourcedata) this.onClear();
        this.assignees = this.multiple ? Object.assign([], this.assigneesChecked) : [this.assigneesChecked];
        if(this.assignees.length) {
          let display = [];
          this.assignee_list.forEach(user => {
            if(this.assignees.indexOf(user.userId) > -1) display.push(user.display)
          })
          this.assignee_display = display.join(',')
        }else{
          this.assignee_display = "";
        }
        this.assigneesPopup = false;
        this.emitInput();
      },
      assigneesCancel() {
        this.assigneesPopup = false;
      },
      circulatorsConfirm() {
        this.circulators = Object.assign([], this.circulatorChecked);
        if(this.circulators.length) {
          let userNames = [];
          this.circulator_list.forEach(user => {
            if(this.circulators.indexOf(user.userId) > -1) userNames.push(user.display)
          })
          this.circulator_display = userNames.join(',')
        }else{
          this.circulator_display = "";
        }
        this.circulatorsPopup = false;
        this.emitInput();
      },
      circulatorsCancel() {
        this.circulatorsPopup = false;
      },
      $_loadtreeSearch(keyword) {
        getUsers({
          "appName": keyword
        }).then( data => {
          let tempArr  = data.map( item => {
            item.display = item.name + "(" + encode18bit(item.id) + ")";
            return item
          })
          this.treeSearchOptions = tempArr;
        })
      },
      $_loadTreeOptions(id) {
        getUsers({ 
          "searchKey": id ||'' 
        }).then( data => {
          this.treeOptions = this.treeDataTranslation(data);
        })
      },
      /**新增添加办理人*/
      $_getAddAssigneesSelected(ids, label, selectors){
        if(this.multiple){
          console.log(ids, label, selectors, ' _getAddAssigneesSelected');
          this.assigneesAdd = ids;
          this.keyName2 = label;
          selectors = this.setEchoStyle(selectors, { "userId": "id", "userName": "name", "deptName": "superName" });
          let names = [];
          selectors.forEach( item => {
            names.push(item.display);
          })
          this.add_assignees_display = names.join(',');
        }else {
          this.assigneesAdd = ids.id;
          this.keyName2 = ids.names;
          this.assignee_display = this.setEchoStyle([ids], { "userId": "id", "userName": "name", "deptName": "superName" })[0].display;
        }
        this.emitInput();
    },

      $_getNextAssigneesSelected(ids, label, selectors) {
        if(this.multiple){
          this.assignees = ids;
          this.keyName = label;
          selectors = this.setEchoStyle(selectors, { "userId": "id", "userName": "name", "deptName": "superName" });
          let names = [];
          selectors.forEach( item => {
            names.push(item.display);
          })
          this.assignee_display = names.join(',');
        } else {
          this.assignees = ids.id;
          this.keyName = ids.name;
          this.assignee_display = this.setEchoStyle([ids], { "userId": "id", "userName": "name", "deptName": "superName" })[0].display;
        }
        this.emitInput();
      },
      $_getCirculatorSelected(ids, label, selectors) {
        this.circulators = ids;
        this.keyName1 = label;
        selectors = this.setEchoStyle(selectors, { "userId": "id", "userName": "name", "deptName": "superName" });
        this.circulator_display = "";
        let names = []
        selectors.forEach( item => {
          names.push(item.display);
        })
        this.circulator_display = names.join(',');
        this.emitInput();
      },
      /**
       * 联动表单，表单相关数据变更触发。当且仅流程设计器已配置下一步节点时，刷新下一步组件  (需求来自王志伟2019/4/24)
       */
      linkFormChange(formdata, callback) {
        if(!this.isFinishedTask && this.showNextNode) {
          this.cur_node = {};
          this.nodeIdIndex = 0;
          this.node = "";
          this.node_display = "";
          this.assignees = [];
          this.assignee_display = "";
          this.keyName = "";
          this.assigneesChecked = this.multiple ? [] : '';
          this.assignee_list = [];
          this.getNextNodes(formdata, callback);
        } else {
          callback && callback();
        }
      },
      updateNextAssignees(formdata, callback) {
        if(!this.isFinishedTask && this.showNextAssignees && this.cur_node.nodeId) {
          this.assignees = [];
          this.assignee_list = [];
          this.customNextAssigneesList = [];
          this.getAssignees(formdata, callback);
        } else {
          callback && callback();
        }
      },
      /**
       * 校验说明：根据下一步节点、下一步办理人的显示/不显示来确定是否校验
       */
      validate() {
        let result = this.validateDefault();
        if(!result.valid) this.toastMsg(result.msg);
        return result.valid
      },
      toastMsg(msg) {
        this.$toast(msg);
      },
      /**
       * 树数据统一化处理
       */
      treeDataTranslation (data) {
        return data.map(obj => {
          if(obj.type === "group") {
            obj.isParent = 1;
          } else {
            obj.isParent = 0;
            obj.display = obj.name +  + "(" + encode18bit(obj.id) + ")";
          }
          obj.pId = obj.superId ? obj.superId : '';
          return obj
        });
      }
    },
    mounted() {
      // do something...
    } 
  }
</script>
<style>
  .emap-flow-next-step-m .emap-flow-next-step-item {
    border-bottom: 1px solid #EDF2FB;
  }
  .selected {
    color: #323233;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  .checkbox-group-container {
    height: 266px;
    overflow: auto;
  }
</style>